/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Manager_Created_ToastInputs */

const en_tags_manager_created_toast = /** @type {(inputs: Tags_Manager_Created_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New tag set created`)
};

const fr_tags_manager_created_toast = /** @type {(inputs: Tags_Manager_Created_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouvel ensemble de tags cree`)
};

const de_tags_manager_created_toast = /** @type {(inputs: Tags_Manager_Created_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neues Tag-Set erstellt`)
};

const it_tags_manager_created_toast = /** @type {(inputs: Tags_Manager_Created_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuovo set di tag creato`)
};

const ru_tags_manager_created_toast = /** @type {(inputs: Tags_Manager_Created_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создан новый набор тегов.`)
};

const es_tags_manager_created_toast = /** @type {(inputs: Tags_Manager_Created_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuevo conjunto de etiquetas creado`)
};

const zh_cn2_tags_manager_created_toast = /** @type {(inputs: Tags_Manager_Created_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建了新的标签集`)
};

const ja_tags_manager_created_toast = /** @type {(inputs: Tags_Manager_Created_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいタグセットが作成されました`)
};

const hi_tags_manager_created_toast = /** @type {(inputs: Tags_Manager_Created_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नया टैग सेट बनाया गया`)
};

const pt_pt2_tags_manager_created_toast = /** @type {(inputs: Tags_Manager_Created_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novo conjunto de tags criado`)
};

/**
* | output |
* | --- |
* | "New tag set created" |
*
* @param {Tags_Manager_Created_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_manager_created_toast = /** @type {((inputs?: Tags_Manager_Created_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Manager_Created_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_tags_manager_created_toast(inputs)
	if (locale === "de") return de_tags_manager_created_toast(inputs)
	if (locale === "it") return it_tags_manager_created_toast(inputs)
	if (locale === "ru") return ru_tags_manager_created_toast(inputs)
	if (locale === "es") return es_tags_manager_created_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_tags_manager_created_toast(inputs)
	if (locale === "ja") return ja_tags_manager_created_toast(inputs)
	if (locale === "hi") return hi_tags_manager_created_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_tags_manager_created_toast(inputs)
	return en_tags_manager_created_toast(inputs)
});